
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/create-account",
      function () {
        return require("private-next-pages/create-account.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/create-account"])
      });
    }
  